import Home from '../components/views/Home'
import Projects from '../components/views/Projects'
import Project from '../components/views/Project'
import SupraSolar from '../components/views/SupraSolar'
import Services from '../components/views/Services'
import Service from '../components/views/Service'
import About from '../components/views/About'
import Contact from '../components/views/Contact'
import Cookies from '../components/views/Cookies'
import NotFound from '../components/views/NotFound'
import Reference from '../components/views/Reference'
import PrivacyPolicy from '../components/views/PrivacyPolicy'
import Gdpr from '../components/views/Gdpr'

export default [
    {
        path: '/',
        name: 'index',
        component: Home
    },
    {
        path: '/suprasolar',
        name: 'suprasolar',
        component: SupraSolar
    },
    {
        path: '/usluge',
        name: 'services',
        component: Services
    },
    {
        path: '/usluge/:slug',
        name: 'service',
        component: Service
    },
    {
        path: '/projekti',
        name: 'projects',
        component: Projects
    },
    {
        path: '/projekti/usluge/:service',
        name: 'projects-by-service',
        component: Projects
    },
    {
        path: '/projekti/:slug',
        name: 'project',
        component: Project
    },
    {
        path: '/o-nama',
        name: 'about',
        component: About
    },
    {
        path: '/reference',
        name: 'reference',
        component: Reference
    },
    {
        path: '/kontakt',
        name: 'contact',
        component: Contact
    },
    {
        path: '/kolacici',
        name: 'cookies',
        component: Cookies
    },
    {
        path: '/pravila-privatnosti',
        name: 'privacy-policy',
        component: PrivacyPolicy,

    },
    {
        path: '/uvjeti-privatnosti-i-obrade-podataka',
        name: 'gdpr',
        component: Gdpr,

    },
    {
        'path': '/supranet.asp',
        'redirect': { name: 'index', query: {} }
    },
    {
        'path': '/pages.asp',
        'redirect': to => {
            const { query } = to

            if (query.category == 105) {
                return { name: 'about', query: {} }
            }

            if (query.category == 140) {
                return { name: 'services', query: {} }
            }

            if (query.category == 104) {
                return { name: 'reference', query: {} }
            }

            if (query.category == 106) {
                return { name: 'contact', query: {} }
            }

            if (query.category == 101) {
                return {
                    name: 'service',
                    params: { slug: 'strukturno-kabliranje' },
                    query: {}
                }
            }

            if (query.category == 108) {
                return {
                    name: 'service',
                    params: { slug: 'distribucija' },
                    query: {}
                }
            }
        }
    },
    {
        path: '/*',
        name: 'not-found',
        component: NotFound,
        alias: '/404'
    }
]
